import assert from '@/sui/tools/assert'

const list = function (vm) {
  return {
    shortkey: ['enter'],
    wait: 250,

    tooltip: function () {
      return `
Validation automatique dès qu'il n'y a plus qu'un seul élément dans la liste`
    },

    display: function (v) {
      if (v == null) {
        return v
      }

      const { displayValue } = vm.parameters.context
      if (displayValue) {
        return v.value
      }

      return v.code
    },

    value: function (v) {
      if (v == null) {
        return null
      }

      if (vm.listValues == null) {
        return { value: v, code: v }
      }

      const r = vm.listValues.find(e => e.code === v)
      if (r == null) {
        return { value: v, code: v }
      }

      return r
    },

    select: function () {
      vm.$nextTick(function () {
        if (vm.selected) {
          vm.$refs.input.select()
        }
      })
    },

    valid: function (v) {
      return true
    },

    result: function (v) {
      let result = v

      const type = vm.$refs.type
      if (type.open) {
        result = type.items[type.activeIndex]
      }

      if (result != null) {
        return { valid: true, value: result.code }
      }

      const { defaultValue, values, optional } = vm.parameters.context
      if (!optional) {
        return { valid: false, value: null }
      }

      assert.notNull(defaultValue)
      return { valid: true, value: values[defaultValue].code }
    },

    confirm: function () {
      const type = vm.$refs.type
      return type != null && vm.text !== '' && vm.result != null &&
        (!type.open || type.items.length === 1)
    },

    checkSelection: function () {
      const type = vm.$refs.type
      if (type != null && type.items.length === 1) {
        type.selectItem(type.items[0])
        vm.$refs.input.blur()
      }
    }
  }
}

const text = function (vm) {
  const multiline = vm.parameters.context.multiline
  const shortkey = multiline ? ['ctrl', 'enter'] : [ 'enter' ]
  const wait = multiline ? null : 1200
  const confirm = multiline ? function () { return false } : null

  return {
    wait: wait,
    shortkey: shortkey,
    confirm,
    display: function (v) {
      return v == null ? v : v.replaceAll('\n', '<br>')
    },

    tooltip: function () {
      return `Validation automatique dès que l'utilisateur arrête de taper.`
    },

    value: function (v) { return v },
    select: function () { vm.$refs.input.select() },
    valid: function (v) {
      const { optional } = vm.parameters.context
      if (optional && (v == null || v === '')) {
        return true
      }

      return v != null && v !== ''
    },
    result: function (v) { return { valid: true, value: v } }
  }
}

const numeric = function (vm) {
  return {
    shortkey: ['enter'],
    options: function () {
      return {
        blocks: [vm.parameters.context.digits],
        numericOnly: true
      }
    },

    wait: 1000,
    display: function (v) {
      if (v == null) {
        return null
      }

      const unit = vm.parameters.context.unit
      return unit != null ? `${v} ${unit}` : v
    },

    tooltip: function () {
      return `Validation automatique dès que les ${vm.params.digits} chiffres
sont saisis ou que l'utilisateur arrête de taper.`
    },

    value: function (v) { return v },
    select: function () { vm.$refs.input.$el.select() },
    valid: function (v) {
      const { optional } = vm.parameters.context
      if (optional && (v == null || v === '')) {
        return true
      }

      return v != null && v !== ''
    },
    result: function (v) {
      return {
        valid: true,
        value: v === '' ? null : v
      }
    }
  }
}

const date = function (vm) {
  return {
    wait: 500,
    shortkey: ['enter'],
    options: function () {
      return {
        date: true,
        datePattern: ['d', 'm', 'Y']
      }
    },

    tooltip: function () {
      return `Validation automatique dès que la date est complète et valide.`
    },

    display: function (v) {
      return v
    },

    value: function (v) { return v },
    select: function () { vm.$refs.input.$el.select() },

    valid: function (v) {
      const { optional } = vm.parameters.context
      if (optional && (v == null || v === '')) {
        return true
      }

      const check = /(3[01]|[12][0-9]|0[1-9])\/(0[1-9]|1[0-2])\/([12][0-9][0-9][0-9])/
      return v != null && v.match(check) != null
    },

    result: function (v) { return { valid: true, value: v } }
  }
}

export default function (vm) {
  return {
    list: list(vm),
    text: text(vm),
    numeric: numeric(vm),
    date: date(vm)
  }
}
